import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({providedIn: 'root'})
export class CountryName {

  constructor ( private translateService: TranslateService ) {}
  
  getCountryName(code: string) {
    
    const countryMap: Record<string, string> = {
      'ARG': this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.ARG'),
      'BRA': this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.BRA'),
      'CHL': this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.CHL'),
      'COL': this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.COL'),
      'VEN': this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.VEN')
    }

    return countryMap[code] || code;
  }


  getCodeFromName(name: string): string {
    const countryMap: Record<string, string> = {
      'ARG': this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.ARG'),
      'BRA': this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.BRA'),
      'CHL': this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.CHL'),
      'COL': this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.COL'),
      'VEN': this.translateService.instant('TRANSLATE.CHOOSE.COUNTRY.VEN')
    };

    const code = Object.keys(countryMap).find(key => countryMap[key] === name);
    return code || name;
  }
 
}